import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_Module1 = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Module 1 (ALL)"
      videos={[
        "https://www.youtube.com/embed/zAXAb_ttazY", // Block Diagram & Architecture of 8085 Microprocessor
      ]}
      takeaways={[
        { text: "Block diagram of microprocessor" },
        { text: "Difference between i3, i5, i7" },
        { text: "Difference between microprocessor and microcontroller" },
        { text: "Difference between 8085 (8-bit) and 8086 (16-bit)" },
        { text: "Difference between Von Neumann and Harvard Architecture" },
        { text: "Follow any extra topics mentioned by your teacher." },
      ]}
      questions={[
        "Explain the block diagram of a microprocessor.",
        "Differentiate between i3, i5, and i7 processors.",
        "What is the key difference between a microprocessor and a microcontroller?",
        "How do 8085 and 8086 processors differ in terms of architecture and operations?",
        "Compare Von Neumann and Harvard architectures with examples.",
      ]}
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_Module1;
